import { useRouter } from "next/router";

import { useEffect, useMemo, useState } from "react";

import findIndex from "lodash/findIndex";
import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import Swipper from "components/Swipper";
import useAuthentication from "hooks/useAuthentication";

import ProfilePageHeader from "../ProfilePageHeader";
import ProfilePageTabs from "../ProfilePageTabs";
import styles from "../style.module.scss";

interface Props {
  profile: any;
  isCompany: any;
  slug: string;
  children: any;
}

export default function ProfilePageLayoutMobile({
  profile,
  isCompany,
  slug,
  children,
}: Props) {
  const router = useRouter();
  const [index, setIndex] = useState(0);

  const { authenticated } = useAuthentication();

  const {
    showAnalysisTab,
    showDiscussionsTab,
    showTeamTab,
    showPremiumServicesTab,
  } = profile || {};

  const tabs = useMemo(
    () => [
      ...(showAnalysisTab
        ? [
            {
              name: "Research",
              href: `/${isCompany ? "companies" : "profiles"}/${slug}/research`,
            },
          ]
        : []),
      ...(showDiscussionsTab
        ? [
            {
              name: "Discussions",
              noFollow: true,
              href: `/${
                isCompany ? "companies" : "profiles"
              }/${slug}/discussions`,
            },
          ]
        : []),
      {
        name: "About",
        noFollow: true,
        href: `/${isCompany ? "companies" : "profiles"}/${slug}/about`,
      },
      ...(showTeamTab
        ? [
            {
              name: "Team",
              href: `/${isCompany ? "companies" : "profiles"}/${slug}/team`,
            },
          ]
        : []),
      ...(authenticated && showPremiumServicesTab
        ? [
            {
              name: "Premium Subscriptions",
              href: `/${
                isCompany ? "companies" : "profiles"
              }/${slug}/premium-subscriptions`,
            },
          ]
        : []),
    ],
    [
      authenticated,
      isCompany,
      showAnalysisTab,
      showDiscussionsTab,
      showPremiumServicesTab,
      showTeamTab,
      slug,
    ]
  );

  useEffect(() => {
    const currentIndex = findIndex(tabs, ["href", router.asPath]);
    setIndex(currentIndex);
  }, [router.asPath, tabs]);

  return (
    <div className={twMerge(styles.mobileLayout, "mt-[54px]")}>
      <CustomCard className={styles.card}>
        {profile && <ProfilePageHeader {...{ profile: profile, isCompany }} />}
      </CustomCard>
      <ProfilePageTabs slug={slug} profile={profile} />
      <Swipper
        index={index}
        maxIndex={tabs.length}
        onIndexChange={(index) => {
          router.push(tabs[index].href, undefined, {
            shallow: true,
            scroll: false,
          });
        }}
      >
        <div className="bg-white mx-[-5px] mt-[15px]">{children}</div>
      </Swipper>
    </div>
  );
}
